import React from 'react';
import { Card, CardContent, Typography, TextField } from '@mui/material';

interface AdvancedSettingsTabProps {
    cssOverride: string;
    onCssOverrideChange: (value: string) => void;
}

export const AdvancedSettingsTab: React.FC<AdvancedSettingsTabProps> = ({
    cssOverride,
    onCssOverrideChange
}) => {
    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    CSS Override
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                    Add custom CSS to override default styles for the welcome board
                </Typography>
                <TextField
                    fullWidth
                    label="Custom CSS"
                    value={cssOverride}
                    onChange={(e) => onCssOverrideChange(e.target.value)}
                    multiline
                    rows={12}
                    placeholder="Enter custom CSS to override default styles..."
                />
            </CardContent>
        </Card>
    );
};
